var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"block w-full h-10 p-2 pr-8 placeholder-gray-400 bg-no-repeat border border-gray-300 rounded appearance-none cursor-pointer",domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }